// metadata/reflect.ts
var noPropertyNameGivenSymbol = Symbol("no property name");
var BQLReflect = class {
  static {
    this.metaDataMap = /* @__PURE__ */ new WeakMap();
  }
  static setMetadata(data, target, propertyKey = noPropertyNameGivenSymbol) {
    if (!this.metaDataMap.has(target))
      this.metaDataMap.set(target, /* @__PURE__ */ new Map());
    this.metaDataMap.get(target).set(propertyKey, data);
  }
  static getMetadata(target, propertyKey = noPropertyNameGivenSymbol) {
    return this.metaDataMap.get(target)?.get(propertyKey);
  }
};
export {
  BQLReflect
};
